<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
    >
        <g clip-path="url(#clip0_21597_9530)">
            <path
                d="M10.5713 5.71436C11.8595 5.71436 13.0949 6.22609 14.0058 7.13699C14.9167 8.04788 15.4284 9.28331 15.4284 10.5715C15.4315 11.5276 15.1489 12.4628 14.617 13.2572L15.4284 15.4286L12.697 14.9372C12.0401 15.2576 11.3194 15.4256 10.5886 15.4286C9.85776 15.4317 9.13566 15.2698 8.47608 14.955C7.8165 14.6403 7.23647 14.1806 6.77919 13.6106C6.32191 13.0405 5.99916 12.3746 5.83503 11.6624C5.67089 10.9502 5.66956 10.2102 5.83118 9.49745C5.99279 8.78471 6.31315 8.11763 6.7684 7.5459C7.22364 6.97417 7.80204 6.51256 8.46049 6.19544C9.11895 5.87832 9.84047 5.71388 10.5713 5.71436Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11.2694 2.86883C10.4998 1.88948 9.44395 1.17448 8.24887 0.82339C7.0538 0.472297 5.77899 0.502581 4.60193 0.910022C3.42488 1.31747 2.40417 2.08179 1.6819 3.09658C0.959635 4.11135 0.571764 5.32611 0.572292 6.57168C0.568751 7.75568 0.918959 8.91376 1.578 9.8974L0.572292 12.5716L2.99515 12.1374"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_21597_9530">
                <rect width="16" height="16" fill="currentColor" />
            </clipPath>
        </defs>
    </svg>
</template>
